import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=706c2e68"
import script from "./Email.vue?vue&type=script&lang=js"
export * from "./Email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('706c2e68')) {
      api.createRecord('706c2e68', component.options)
    } else {
      api.reload('706c2e68', component.options)
    }
    module.hot.accept("./Email.vue?vue&type=template&id=706c2e68", function () {
      api.rerender('706c2e68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/Email.vue"
export default component.exports